import React from 'react';

const Dieticians: React.FC = () => {
  return <div>Dieticians</div>;
};
export default Dieticians;
